export default __webpack_public_path__ + "static/media/nw_bamboo_logo_soft.32bb9950.png";